import { SelectItem } from 'primeng/api';
import { ApprovalStatus } from '../enums';

export class ApprovalStatusesLookup {

    static getLookup() {
        return [
            { label: 'Pending', id: ApprovalStatus.Pending, class: 'fas fa-circle fa-sm palette-Amber text' },
            { label: 'Approved', id: ApprovalStatus.Approved, class: 'fas fa-circle fa-sm palette-Green-500 text' },
            { label: 'Rejected', id: ApprovalStatus.Rejected, class: 'fas fa-circle fa-sm palette-Red text' },
            { label: 'Canceled', id: ApprovalStatus.Canceled, class: 'fas fa-circle fa-sm palette-Grey-500 text' },
            { label: 'Referred', id: ApprovalStatus.Referred, class: 'fas fa-circle fa-sm palette-Purple text' },
            { label: 'Approval Request', id: ApprovalStatus.ApprovalRequest, class: 'fas fa-circle fa-sm palette-Amber-900 text' },
            { label: 'Further Details', id: ApprovalStatus.FurtherDetails, class: 'fas fa-circle fa-sm palette-Blue text' },
        ]
    }

        static getValueLookup() {
        return [
            { label: 'Pending', value: ApprovalStatus.Pending },
            { label: 'Approved', value: ApprovalStatus.Approved },
            { label: 'Rejected', value: ApprovalStatus.Rejected },
            { label: 'Canceled', value: ApprovalStatus.Canceled },
            { label: 'Referred', value: ApprovalStatus.Referred },
            { label: 'Approval Request', value: ApprovalStatus.ApprovalRequest },
            { label: 'Further Details', value: ApprovalStatus.FurtherDetails },
        ]
    }

    private static statusLookup = {
        [ApprovalStatus.Pending]: [
            { label: 'Approved', value: ApprovalStatus.Approved },
            { label: 'Rejected', value: ApprovalStatus.Rejected },
            { label: 'Canceled', value: ApprovalStatus.Canceled },
            { label: 'Referred', value: ApprovalStatus.Referred },
            { label: 'Further Details', value: ApprovalStatus.FurtherDetails },
        ],
        [ApprovalStatus.Approved]: [
            { label: 'Pending', value: ApprovalStatus.Pending },
            { label: 'Rejected', value: ApprovalStatus.Rejected },
            { label: 'Canceled', value: ApprovalStatus.Canceled },
        ],
        [ApprovalStatus.Rejected]: [
            { label: 'Pending', value: ApprovalStatus.Pending },
            { label: 'Approved', value: ApprovalStatus.Approved },
            { label: 'Canceled', value: ApprovalStatus.Canceled },
            { label: 'Referred', value: ApprovalStatus.Referred },
            { label: 'Further Details', value: ApprovalStatus.FurtherDetails },
        ],
        [ApprovalStatus.Referred]: [
            { label: 'Pending', value: ApprovalStatus.Pending },
            { label: 'Approved', value: ApprovalStatus.Approved },
            { label: 'Rejected', value: ApprovalStatus.Rejected },
            { label: 'Canceled', value: ApprovalStatus.Canceled },
            { label: 'Further Details', value: ApprovalStatus.FurtherDetails },
        ],
        [ApprovalStatus.FurtherDetails]: [
            { label: 'Pending', value: ApprovalStatus.Pending },
            { label: 'Approved', value: ApprovalStatus.Approved },
            { label: 'Rejected', value: ApprovalStatus.Rejected },
            { label: 'Canceled', value: ApprovalStatus.Canceled },
        ],
        [ApprovalStatus.ApprovalRequest]: [
            { label: 'Rejected', value: ApprovalStatus.Rejected },
            { label: 'Canceled', value: ApprovalStatus.Canceled },
            { label: 'Referred', value: ApprovalStatus.Referred },
            { label: 'Further Details', value: ApprovalStatus.FurtherDetails },
        ],
    };

    static getStatusOptions(status: ApprovalStatus): SelectItem[] {
        return this.statusLookup[status] || [];
    }

    static getClassById(id) {
        const lookup = this.getLookup().find(f => f.id === id)?.class;
        return lookup;
    }
}
